import { Link } from "react-router-dom";

import { miscConstants } from './../../utils/miscConstants';
// import { CardItemType } from '../../utils/types/types';
// import { ProductItemType } from '../../utils/types/types';
import IProductItem from './../../utils/interfaces/IProductItem';
import ProductCardWrapper from './ProductCard.styles';
import Image from './../common/Image/Image';

// import ICardItem from './../../utils/interfaces/ICardItem';

type Props = {
    productItem: IProductItem;
}

const ProductCard: React.FC<Props> = ({ productItem }) => {
    return <ProductCardWrapper>
        {/* <Link className="product-card" to={`/products/${productItem.id}`}> */}
        <Link className="product-card" to={`${miscConstants.baseUrl}/products/${productItem.id}`}>
            <span className="card-inner">
                <div className="details">
                    Details
                </div>
                <Image image={productItem.images[0]} imageClass="card-media" productItemName={productItem.name} />
                <span className="card-meta">
                    <p className="manufacturer">{productItem.manufacturer}</p>
                    <h6>{productItem.name}</h6>
                </span>
                <span className="card-footer">
                    <h6 className="price">{productItem.price} DKK</h6>
                </span>
            </span>
        </Link >
    </ProductCardWrapper>
}

export default ProductCard;